import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "subs enabled" };
var _hoisted_2 = { class: "text-center" };
var _hoisted_3 = { class: "text-center" };
var _hoisted_4 = { class: "row pt-4" };
var _hoisted_5 = { class: "col-12 col-sm-6 col-md-4" };
var _hoisted_6 = { class: "col-12 col-sm-6 col-md-4" };
var _hoisted_7 = { class: "col-12 col-sm-12 col-md-4" };
var _hoisted_8 = { class: "d-flex align-items-center justify-content-between" };
var _hoisted_9 = { key: 0 };
var _hoisted_10 = {
    key: 1,
    class: "form-group"
};
var _hoisted_11 = { class: "d-flex align-items-center" };
var _hoisted_12 = {
    key: 2,
    class: "credentials"
};
import { ref } from 'vue';
import { dateFormat } from '@/utils/dateformat';
import { getCredentials } from '@/api/public/client';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubData',
    props: {
        suscription: {}
    },
    setup: function (__props) {
        var _this = this;
        var credentials = ref({
            email: '',
            password: '',
        });
        var requestCred = ref(0);
        var seePass = ref(false);
        var password = ref('');
        var showCredentials = function () {
            if (requestCred.value === 0) {
                requestCred.value = 1;
            }
            else {
                requestCred.value = 0;
                seePass.value = false;
            }
        };
        var sendPass = function (sid) { return __awaiter(_this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCredentials({ password: password.value, sid: sid })];
                    case 1:
                        response = _a.sent();
                        credentials.value = response.data;
                        requestCred.value = 2;
                        seePass.value = true;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error al obtener las credenciales:', error_1);
                        seePass.value = false;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _a, _b, _c;
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h4", _hoisted_2, _toDisplayString((_b = (_a = _ctx.suscription.group) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.name), 1),
                _createElementVNode("h5", _hoisted_3, _toDisplayString((_c = _ctx.suscription.group) === null || _c === void 0 ? void 0 : _c.groupName), 1),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("dl", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("dt", null, "Precio", -1)),
                            _createTextVNode("$us " + _toDisplayString(_ctx.suscription.cost), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("dl", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("dt", null, "Fecha de solicitud", -1)),
                            _createTextVNode(_toDisplayString(_unref(dateFormat)(_ctx.suscription.createdAt, 'DD MMMM')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            (requestCred.value === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Mostrar credenciales de la cuenta"))
                                : _createCommentVNode("", true),
                            (requestCred.value === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _cache[4] || (_cache[4] = _createElementVNode("label", null, [
                                        _createElementVNode("small", null, "Ingrese su contraseña")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_11, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-control",
                                            type: "password",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((password).value = $event); })
                                        }, null, 512), [
                                            [_vModelText, password.value]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "btn btn-success ms-2",
                                            onClick: _cache[1] || (_cache[1] = function ($event) { return (sendPass(_ctx.suscription.id)); })
                                        }, [
                                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'paper-plane'] })
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (requestCred.value === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("p", null, [
                                        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Correo: ", -1)),
                                        _createTextVNode(_toDisplayString(credentials.value.email), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                        _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Contraseña: ", -1)),
                                        _createTextVNode(_toDisplayString(credentials.value.password), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                class: "btn btn-light",
                                onClick: showCredentials
                            }, [
                                _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', seePass.value ? 'eye' : 'fa-eye-slash']
                                }, null, 8, ["icon"])
                            ])
                        ])
                    ])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1))
            ]));
        };
    }
});
